import React from 'react';
import { Input, Checkbox, Button, Select } from '../../../ui';
import { useBuilderEditor } from '../../../../features/builder/BuilderEditorContext';
import { ALL_FIELD_TYPES } from '../../../../features/builder/fieldRegistry';
import { QuestionType } from '../../../../core/constants/common';
import RadioGridEditor from '../RadioGridEditor';
import TableEditor from '../TableEditor';
import GridQuestionEditor from '../GridQuestionEditor';
import { BiPlus, BiTrash } from 'react-icons/bi';

const GeneralTab = () => {
  const {
    field, setField, markUnsaved, selectedanswertype, changeQuestionType, fieldeditid, isNewField,
    choiceoptions, scoreEnabled, addChoice, removeChoice, updateFieldChanged,
    otherChecked, setOtherChecked, otherText, setOtherText, otherMandatory, setOtherMandatory,
    handleOtherChange,
  } = useBuilderEditor();

  const showOptions = ['RADIO', 'DROP_DOWN', 'MULTI_SELECT_DROP_DOWN', 'MULTIPLE_CHOICE'].includes(selectedanswertype);
  const showOptionHelp = selectedanswertype === 'RADIO' || selectedanswertype === 'MULTIPLE_CHOICE';
  const isRadioGrid = selectedanswertype === QuestionType.RADIO_GRID;
  const isTable = selectedanswertype === QuestionType.TABLE;
  const isGrid = selectedanswertype === QuestionType.GRID;

  return (
    <div className="builder-property-tab">
      {(fieldeditid || isNewField) && (
        <Select
          label="Question type"
          value={selectedanswertype || ''}
          onChange={(e) => changeQuestionType(e.target.value)}
          options={ALL_FIELD_TYPES.map((t) => ({ value: t.key, label: t.name }))}
        />
      )}

      <Input
        label="Question"
        value={field || ''}
        onChange={(e) => { setField(e.target.value); markUnsaved(); }}
        placeholder="Enter your question"
      />

      {showOptions && (
        <div>
          <label className="builder-label">Options</label>
          {choiceoptions.filter((o) => !o.showOthers).map((opt, i) => (
            <div key={i} className="builder-property-tab__option">
              <div className="builder-property-tab__option-fields">
                <input
                  className="builder-ui-input"
                  name="name"
                  value={opt.name || ''}
                  onChange={updateFieldChanged(i)}
                  placeholder={`Option ${i + 1}`}
                />
                {scoreEnabled && (
                  <input
                    className="builder-ui-input builder-property-tab__score-input"
                    type="number"
                    name="score"
                    value={opt.score ?? ''}
                    onChange={updateFieldChanged(i)}
                    placeholder="Score"
                  />
                )}
                {choiceoptions.length > 1 && (
                  <Button variant="ghost" icon={<BiTrash />} aria-label="Remove option" onClick={() => removeChoice(i)} />
                )}
              </div>
              {showOptionHelp && (
                <input
                  className="builder-ui-input builder-property-tab__spacer-top-sm"
                  name="helpText"
                  value={opt.helpText || ''}
                  onChange={updateFieldChanged(i)}
                  placeholder="Help text (optional)"
                />
              )}
            </div>
          ))}
          <Button variant="secondary" size="sm" icon={<BiPlus />} onClick={addChoice}>Add option</Button>

          <div className="builder-property-tab__spacer-top-lg">
            <Checkbox
              label="Add 'Other' option"
              checked={otherChecked}
              onChange={handleOtherChange}
            />
          </div>
          {otherChecked && (
            <div className="builder-property-tab__spacer-top">
              <Input
                value={otherText || ''}
                onChange={(e) => { setOtherText(e.target.value); markUnsaved(); }}
                placeholder="Other (please specify)"
              />
              <Checkbox
                label="Other required"
                checked={otherMandatory}
                onChange={(e) => { setOtherMandatory(e.target.checked); markUnsaved(); }}
              />
            </div>
          )}
        </div>
      )}

      {isRadioGrid && <RadioGridEditor />}
      {isTable && <TableEditor />}
      {isGrid && <GridQuestionEditor key={fieldeditid || 'new'} />}
    </div>
  );
};

export default GeneralTab;
